/* eslint-disable import/prefer-default-export */
export const GET_CONNECTED_DEDICATED_CUSTOMERS = 'GET_CONNECTED_DEDICATED_CUSTOMERS';
